import axios from "axios";
import { useEffect, useState } from "react";

import { MAGNOLIA_NEXT_API_URL, QUOTE_DASHBOARD_URL } from "@/constants";

export type DashboardData = {
  modalTitle: string;
  modalDescription: string;
  ctaButtonLabel: string;
  backButtonLabel: string;
};

const initialData = {
  modalTitle: "Are you sure?",
  modalDescription:
    "By canceling you will lose all unsaved changes you have made to your policy",
  ctaButtonLabel: "Continue",
  backButtonLabel: "Go back",
};

export function useQuoteDashboard() {
  const [data, setData] = useState<DashboardData>(initialData);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const abortController = new AbortController();

    async function fetchDashboard() {
      try {
        const response = await axios.get(
          `${MAGNOLIA_NEXT_API_URL}/${QUOTE_DASHBOARD_URL}`,
          {
            signal: abortController.signal,
          }
        );
        const results = response.data.data;
        if (results) {
          setData({
            modalTitle: results.modalTitle ?? initialData.modalTitle,
            modalDescription:
              results.modalDescription ?? initialData.modalDescription,
            ctaButtonLabel:
              results.ctaButtonLabel ?? initialData.ctaButtonLabel,
            backButtonLabel:
              results.backButtonLabel ?? initialData.backButtonLabel,
          });
        }
      } catch (err) {
        if (!abortController.signal.aborted) {
          setError(
            err instanceof Error
              ? err
              : new Error("Failed to fetch dashboard data")
          );
        }
      } finally {
        if (!abortController.signal.aborted) {
          setIsLoading(false);
        }
      }
    }

    fetchDashboard();

    return () => {
      abortController.abort();
    };
  }, []);

  return { data, isLoading, error };
}
